import { Link } from "react-router-dom";

const ContactSection = () => {
  return (
    <section className="py-20 px-6 bg-muted/30">
      <div className="container mx-auto max-w-4xl text-center">
        <div className="text-[#ef8702] text-center font-black text-lg tracking-[0.8px] mb-4">
          NEED A HAND?
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
          We're Here! Contact Us
        </h2>

        <p className="text-lg text-muted-foreground mb-12 max-w-2xl mx-auto">
          Reach out to us on any of these platforms and we will get back to you
          as soon as possible.
        </p>

        <div className="max-w-2xl mx-auto">
          <div className="shadow-card flex items-center justify-center space-x-2 bg-card">
            <h3 className="font-semibold text-foreground mb-2">
              Speak to a representative
            </h3>
            <Link to="#">
              <p className="text-secondary text-sm mb-4">
                | Chat with our live support
              </p>
            </Link>
          </div>

          <div className="shadow-card flex items-center justify-center space-x-2 bg-card">
            <h3 className="font-semibold text-foreground mb-2">
              Prefer email?
            </h3>
            <Link to="#">
              <p className="text-secondary text-sm mb-4">
                | Submit a support request
              </p>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
